var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{attrs:{"disabled":_vm.loading},on:{"click":function($event){return _vm.$emit('click', $event)}}},[(!_vm.loading)?_vm._t("default"):_c('span',[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "+_vm._s(_vm.text))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }